
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("form/mood",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"moodStarShortcut") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":1,"column":19},"end":{"line":1,"column":358}}})) != null ? stack1 : "")
    + " ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"unstar\" title=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"status.starredBestMoment",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":82},"end":{"line":1,"column":119}}})) != null ? stack1 : "")
    + "\" style=\"font-size:36px;color:#FF6C87;\" >"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_added_to_favorites",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":160},"end":{"line":1,"column":195}}}))
    + "</icon> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <icon data-fw-onclick=\"star\" title=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.starBestMoment",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":248},"end":{"line":1,"column":283}}})) != null ? stack1 : "")
    + "\" style=\"font-size:36px;\" >"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_add_to_favorites",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":310},"end":{"line":1,"column":343}}}))
    + "</icon> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isMoodable") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":366}}})) != null ? stack1 : "")
    + " ";
},"useData":true});
export default TPL;